import { addValidationRule } from '@akihirotakamura/formsy-react'

addValidationRule('isPostal', (values, value) => {
  if (!value || value === '') return true
  return value.match(/^\d{3}[-]\d{4}$/)
})
